import { takeLatest, call, put } from 'redux-saga/effects';
import {  postSuccess, postFailure } from './slice';
import { apiGet, apiPost, apiPut, apiDelete, apiUpload } from '../../../api/client';
function* postRequest(action) {
    try {
        const response = yield call(apiPost, 'api/enquiry', action.payload);
        yield put(postSuccess(response));
    } catch (error) {
        yield put(postFailure(error?.response?.message || error));
    }
}


function* saga() {
    yield takeLatest('enquiry/postRequest', postRequest);
}

export default saga;